/**
 * UNIFIED / 2026 regularization case type: API and legacy DB may use different strings.
 * Advisor–admin UI shows one short English label where tables are not i18n-wrapped.
 */

export const UNIFIED_CASE_TYPE_LABEL_EN = 'Regularization 2026';

const UNIFIED_FORM_NAME_ALIASES = new Set([
  'regularization 2026',
  'extraordinary regularization 2026',
]);

export function isUnifiedRegularization2026FormName(raw) {
  const s = String(raw || '').trim();
  if (!s) return false;
  return UNIFIED_FORM_NAME_ALIASES.has(s.toLowerCase());
}

/** English-only tables (e.g. Admin). */
export function displayUnifiedCaseTypeLabelEn(raw) {
  const s = String(raw || '').trim();
  if (!s || isUnifiedRegularization2026FormName(s)) return UNIFIED_CASE_TYPE_LABEL_EN;
  return s;
}

/** Advisor components using react-i18next. */
export function resolvedAdvisorCaseTypeLabel(formName, t) {
  const s = String(formName || '').trim();
  if (!s) return t('advisorPortal.defaultCaseType');
  if (isUnifiedRegularization2026FormName(s)) return t('advisorPortal.defaultCaseType');
  return s;
}
